import React from "react";
import { useTranslation } from "react-i18next";

const BenefitChangedExpirationType = ({ notification }) => {
  const { t } = useTranslation();

  const benefitName = notification?.payload?.benefitName || "";

  return (
    <>
      <h4 className="notification-title">
        {t("notification_benefit_changed_expiration_type_title", { benefitName })}
      </h4>
      <p className="notification-subtitle">
        {t("notification_benefit_changed_expiration_type_subtitle")}
      </p>
      <p className="subtitle-description">
        {t("notification_benefit_changed_expiration_type_description")}
      </p>
    </>
  );
};

export default BenefitChangedExpirationType;
